<template>
    <form class="form-agent-multi-account" @submit.prevent="onSubmit()">
      <fieldset>
        <legend>{{ $t('AGENT_MGMT.FORM.INFO_USER.LABEL') }}</legend>
        <div class="medium-12 columns">
          <label :class="{ error: $v.agentName.$error }">
            {{ $t('AGENT_MGMT.FORM.NAME.LABEL') }}
            <input
              v-model.trim="agentName"
              type="text"
              :placeholder="$t('AGENT_MGMT.FORM.NAME.PLACEHOLDER')"
              @input="$v.agentName.$touch"
            />
          </label>
        </div>        
        <div class="medium-12 columns" v-if="!isEdit">
          <label :class="{ error: $v.agentEmail.$error }">
            {{ $t('AGENT_MGMT.FORM.EMAIL.LABEL') }}
            <input
              v-model.trim="agentEmail"
              type="text"
              :placeholder="$t('AGENT_MGMT.FORM.EMAIL.PLACEHOLDER')"
              @input="$v.agentEmail.$touch"
            />
          </label>
        </div>
      </fieldset>
      <fieldset>
        <legend>{{ $t('AGENT_MGMT.FORM.PARENT_ACCOUNT.LABEL') }}</legend>
        <div class="medium-12 columns" :class="{ error: $v.accessParent.$error }">
          <multiselect
            v-model="accessParent"
            :options="accessParentOptions"
            :searchable="false" 
            :placeholder="$t('AGENT_MGMT.FORM.PARENT_ACCOUNT.PLACEHOLDER')"             
            track-by="id"
            label="name"
            class="no-margin multiselect-wrap--small"              
          >              
          </multiselect>              
        </div>
      </fieldset>
      <fieldset>
        <legend>{{ $t('AGENT_MGMT.FORM.SUBACCOUNT.LABEL') }}</legend>
        <div class="medium-12 columns">
          <div v-for="(item, index) in accounts" :key="`account-${index}`" class="item-account">
            <div  class="row">
              <div class="columns">
                <multiselect
                  v-model="item.account"
                  :options="getSubaccountOptionsByIndex(index)"
                  :placeholder="$t('AGENT_MGMT.FORM.SUBACCOUNT.PLACEHOLDER')"
                  :disabled="item.loading"
                  track-by="id"
                  label="name"
                  class="no-margin multiselect-wrap--small"
                  @select="subaccount => onChangeSubAccount(subaccount, item)"
                >
                  <template #noResult>
                    <span>{{ $t('AGENT_MGMT.FORM.SUBACCOUNT.NO_RESULTS') }}</span>
                  </template>
                </multiselect>
              </div>
              <div class="columns">
                <multiselect
                  v-model="item.role"
                  :options="roles"
                  :placeholder="$t('AGENT_MGMT.FORM.AGENT_TYPE.PLACEHOLDER')"
                  :disabled="item.loading"
                  track-by="name"
                  label="label"
                  class="no-margin multiselect-wrap--small"              
                >              
                </multiselect>
              </div>
              <template v-if="!isEdit">
                <div class="columns">
                  <multiselect
                    v-model="item.inboxes.selecteds"
                    :options="item.inboxes.options"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :hide-selected="true"
                    :disabled="item.loading"
                    :placeholder="$t('AGENT_MGMT.FORM.SUBACCOUNT_INBOXES.PLACEHOLDER')"
                    track-by="id"
                    label="name"
                    class="no-margin multiselect-wrap--small"              
                  >              
                  </multiselect>
                </div>
                <div class="columns" v-if="showTeamsField(item)">
                  <multiselect
                    v-model="item.teams.selecteds"
                    :options="item.teams.options"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :hide-selected="true"
                    :disabled="item.loading"
                    :placeholder="$t('AGENT_MGMT.FORM.SUBACCOUNT_TEAMS.PLACEHOLDER')"
                    track-by="id"
                    label="name"
                    class="no-margin multiselect-wrap--small"              
                  >              
                  </multiselect>
                </div>
              </template>
              <div class="columns column-actions">
                  <woot-button                    
                    v-tooltip.top="`Remover`"
                    icon="dismiss"
                    variant="clear"
                    color-scheme="secondary"
                    type="button"
                    @click="removeRowAccount(index)"
                  />
              </div>
              <template v-if="item.loading">
                <div class="account-loading-overlay"></div>
                <div class="account-loading"><spinner :colorScheme="'dark'" /></div>
              </template>
              
            </div>
            <div v-if="$v.accounts.$each[index].account.$error || $v.accounts.$each[index].role.$error" class="error mt-2">
              <span v-if="$v.accounts.$each[index].account.$error" class="message">{{ $t('AGENT_MGMT.FORM.SUBACCOUNT.ERROR') }}</span>
              <span v-else-if="$v.accounts.$each[index].role.$error" class="message">{{ $t('AGENT_MGMT.FORM.AGENT_TYPE.ERROR') }}</span>
            </div>
          </div>
          <div v-if="$v.accounts.$error && !$v.accounts.minLength" class="row error">
            <span class="message">{{ $t('AGENT_MGMT.FORM.ERROR_MESSAGE_NOT_SELECTED_PARENT_OR_SUBACCOUNT') }}</span>
          </div>
          <woot-button
            v-if="accounts.length < subaccountsSorted.length"
            icon="add"
            color-scheme="success"
            variant="smooth"
            size="small"
            type="button"
            @click="addRowAccount"
          >
            {{ $t('AGENT_MGMT.FORM.ADD_SUBACCOUNT_BUTTON_TEXT') }}
          </woot-button>
        </div>
      </fieldset>
      <fieldset v-if="shouldTemplatesLimit || shouldAddRules">
        <legend>{{ $t('AGENT_MGMT.FORM.RULES_TEMPLATES_SUBACCOUNTS.LABEL') }}</legend>
        <div class="medium-12 columns">
          <div class="row" v-if="shouldAddRules">
            <div  class="medium-6" v-for="ruleKey in Object.keys(rules)" :key="ruleKey">
              <label class="flex-container">
                {{ getLabelRule(ruleKey) }}<woot-switch v-model="rules[ruleKey]" class="margin-left-1" />
              </label>
            </div>
          </div>
          <div class="row" >
            <div class="medium-6">
              <label class="flex-container">
                {{ getLabelRule('enable_template_limit') }}<woot-switch v-model="enable_template_limit" class="margin-left-1" />
              </label>
            </div>            
          </div>
          <div v-if="enable_template_limit" class="row">
            <div class="medium-3">
              <label
                :class="{
                  error: $v.daily_template_limit.$error,
                }"
              >
                {{ $t('AGENT_MGMT.EDIT.TEMPLATE_LIMIT.DAILY.LABEL') }}

                <input
                  min="1"
                  type="number"
                  v-model="daily_template_limit"
                  @input="$v.daily_template_limit.$touch"
                />
                <span
                  v-if="$v.daily_template_limit.$error"
                  class="message"
                >
                  {{ $t('AGENT_MGMT.EDIT.TEMPLATE_LIMIT.DAILY.ERROR') }}
                </span>
              </label>
            </div>

            <div class="medium-3 margin-left-2">
              <label
                :class="{
                  error: $v.monthly_template_limit.$error,
                }"
              >
                {{ $t('AGENT_MGMT.EDIT.TEMPLATE_LIMIT.MONTHLY.LABEL') }}

                <input
                  min="1"
                  type="number"
                  v-model="monthly_template_limit"
                  @input="$v.monthly_template_limit.$touch"
                />
                <span
                  v-if="$v.monthly_template_limit.$error"
                  class="message"
                >
                  {{ $t('AGENT_MGMT.EDIT.TEMPLATE_LIMIT.MONTHLY.ERROR') }}
                </span>
              </label>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset v-if="isEdit && showResetPassword">
        <legend>{{ $t('SET_NEW_PASSWORD.TITLE') }}</legend>
        <div class="medium-12 columns">
          <label :class="{ error: $v.agentPassword.$error }">
            <input
              v-model.trim="agentPassword"
              type="password"
              :placeholder="$t('SET_NEW_PASSWORD.PASSWORD.PLACEHOLDER')"
              @input="$v.agentPassword.$touch"
            />
            <template v-if="$v.agentPassword.$dirty && $v.agentPassword.$invalid">
              <span v-if="!$v.agentPassword.containsUppercase" class="message">
                {{ $t('SET_NEW_PASSWORD.RECOVER_PASSWORD.UPPERCASE') }}
              </span>
              <span v-if="!$v.agentPassword.containsLowercase" class="message">
                {{ $t('SET_NEW_PASSWORD.RECOVER_PASSWORD.LOWERCASE') }}
              </span>
              <span v-if="!$v.agentPassword.containsNumber" class="message">
                {{ $t('SET_NEW_PASSWORD.RECOVER_PASSWORD.NUMBER') }}
              </span>
              <span v-if="!$v.agentPassword.containsSpecial" class="message">
                {{ $t('SET_NEW_PASSWORD.RECOVER_PASSWORD.SPECIAL') }}
              </span>
            </template>
          </label>
        </div>
      </fieldset>
      <div class="modal-footer">
        <div :class="isEdit ? 'medium-6 columns' : 'medium-12 columns'">
          <woot-submit-button
            type="submit"
            :disabled="
              $v.agentEmail.$invalid ||
              $v.agentName.$invalid ||
              $v.agentPassword.$invalid ||
              isSubmitting
            "
            :button-text="(!isEdit ? $t('AGENT_MGMT.ADD.FORM.SUBMIT'): $t('AGENT_MGMT.EDIT.FORM.SUBMIT'))"
            :loading="isSubmitting"
          />
          <button class="button clear" @click.prevent="$emit('cancel')">
            {{ $t('AGENT_MGMT.FORM.CANCEL_BUTTON_TEXT') }}
          </button>
        </div>
        <div v-if="isEdit" class="medium-6 columns text-right">
          <woot-button
            type="button"
            icon="lock-closed"
            variant="clear"
            @click="showResetPassword = !showResetPassword"
          >
            {{ $t('SET_NEW_PASSWORD.TITLE') }}
          </woot-button>
          <woot-button
            icon="mail"
            variant="clear"
            @click.prevent="resetPassword"
          >
            {{ $t('SET_NEW_PASSWORD.RECOVER_PASSWORD.LABEL') }}
          </woot-button>
        </div>
      </div>
    </form>  
</template>

<script>
import {
  required,
  minLength,
  requiredIf,
  minValue,
  email
} from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';

import InboxesAPI from '../../../../api/inboxes.js';
import TeamsAPI from '../../../../api/teams.js';
import Auth from '../../../../api/auth';
import alertMixin from 'shared/mixins/alertMixin';

import Spinner from 'shared/components/Spinner.vue';

export default {
  components: {
    Spinner
  },
  mixins: [alertMixin],
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      agentName: this.value.name || '',
      agentEmail: this.value.email || '',      
      roles: [
        {
          name: 'administrator',
          label: this.$t('AGENT_MGMT.AGENT_TYPES.ADMINISTRATOR'),
        },
        {
          name: 'team_supervisor',
          label: this.$t('AGENT_MGMT.AGENT_TYPES.TEAM_SUPERVISOR'),
        },
        {
          name: 'supervisor',
          label: this.$t('AGENT_MGMT.AGENT_TYPES.SUPERVISOR'),
        },
        {
          name: 'agent',
          label: this.$t('AGENT_MGMT.AGENT_TYPES.AGENT'),
        },
        {
          name: 'seller',
          label: this.$t('AGENT_MGMT.AGENT_TYPES.SELLER'),
        },
        {
          name: 'analyzer',
          label: this.$t('AGENT_MGMT.AGENT_TYPES.ANALYZER'),
        },
        {
          name: 'assistant',
          label: this.$t('AGENT_MGMT.AGENT_TYPES.ASSISTANT'),
        },
        {
          name: 'embed',
          label: this.$t('AGENT_MGMT.AGENT_TYPES.EMBED'),
        },
      ],      
      accessParent: null,
      accessParentOptions: [
        {id: 0, name: 'Não'},
        {id: 1, name: 'Sim'},
      ],
      accounts: [],
      rules: {
        unassigned: true,
        contact: true,
        mask_number: true,
        campaign: false,
        portal: false,
        export_contacts: false,
        change_conversation_assignment: false,
        multi_conversation_selector: false,
        call_outgoing: false,
        create_shortcut: true
      },
      enable_template_limit: false,
      daily_template_limit: null,
      monthly_template_limit: null,
      agentPassword: null,
      showResetPassword: false
    };
  },
  computed: {
    ...mapGetters({     
      subaccounts: 'subaccounts/getSubaccounts',
      currentAccountId: 'getCurrentAccountId',
    }),
    subaccountsSorted(){
      return [...this.subaccounts].sort((a, b) =>
        a.name.localeCompare(b.name, 'pt-BR', { sensitivity: 'base' })
      );
    },
    isEdit() {
      return Object.keys(this.value).length > 0;
    },
    shouldAddRules(){
      if(this.isEdit || this.accounts.length === 0){
        return false;
      }
      return this.accounts.some((item) => {
        return (
          item.account && item.role
          && !['administrator', 'team_supervisor'].includes(item.role.name)
        )
      })
    },
    shouldTemplatesLimit(){
      return !this.isEdit && this.accounts.length > 0;
    }
  },
  watch: {
    value: {
      // A função handler será executada logo na criação do componente
      handler(value) {
        if(value?.account_users){
          const accessParentAccount = value.account_users.find(account_user => account_user.account.id === this.currentAccountId);
          this.accessParent = this.accessParentOptions.find(option => option.id === (accessParentAccount ? 1 : 0));
          this.accounts = value.account_users.filter(account_user => account_user.account.id !== this.currentAccountId).map((account_user) => {
            return {
              ...this.getMockupAccount(),
              account: account_user.account,
              role: this.roles.find(role => role.name === account_user.role),
            }
          });
        }else{
          this.accessParent = null;
          this.accounts = [];
        }
      },      
      immediate: true
    }
  },
  validations() {
    return {
      agentName: {
        required,
        minLength: minLength(1),
      },
      agentPassword: {
        minLength: minLength(6),
        required: requiredIf(function () {
          return this.isEdit && this.showResetPassword;
        }),
        containsUppercase: val => !this.showResetPassword || /[A-Z]/.test(val),
        containsLowercase: val => !this.showResetPassword || /[a-z]/.test(val),
        containsNumber: val => !this.showResetPassword || /[0-9]/.test(val),
        containsSpecial: val => !this.showResetPassword || /[#?!@$%^&*-]/.test(val),
      },
      agentEmail: {
        required,
        email,
      },
      accessParent: {
        required,
      },
      accounts: {
        minLength: (value) => {             
          if (this.accessParent === null || this.accessParent.id === 1) return true
          return value.length >= 1
        },
        $each: {        
          account: {
            required: requiredIf(() => this.accounts.length > 0),
          },
          role: {
            required: requiredIf(() => this.accounts.length > 0),
          },
        }
      },
      daily_template_limit: {
        minValue: minValue(1),
        required: requiredIf(function () {
          return (
            this.shouldTemplatesLimit &&
            this.enable_template_limit &&
            !this.monthly_template_limit
          );
        }),
      },
      monthly_template_limit: {
        minValue: minValue(this.daily_template_limit),
        required: requiredIf(function () {
          return (
            this.shouldTemplatesLimit &&
            this.enable_template_limit &&
            !this.daily_template_limit
          );
        }),
      },    
    }
  },  
  mounted() {    
    if(this.subaccounts.length === 0){
      this.$store.dispatch('subaccounts/get');
    }    
  },
  methods: {
    onSubmit() {
      this.$v.$touch()
      if (this.$v.$invalid) return;      

      let accountsAdd = this.accounts.map(item => {
        let data = {
          id: item.account.id,
          role: item.role.name,
          inboxes: item.inboxes.selecteds.map((inbox) =>  inbox.id)
        }
        if(this.showTeamsField(item)){
          data.teams = item.teams.selecteds.map((team) =>  team.id);
        }
        return data;
      });
      if(this.accessParent.id){
        accountsAdd.push({
          id: this.currentAccountId,
          role: 'administrator',
        });
      }
      let dataSubmit = {
        name: this.agentName,
        email: this.agentEmail,
        accounts: accountsAdd
      }
      if(this.isEdit && this.showResetPassword){
        dataSubmit.password = this.agentPassword;
      }
      if(this.shouldAddRules){
        dataSubmit.rules = this.clone(this.rules);
      }
      if(this.shouldTemplatesLimit && this.enable_template_limit){
        dataSubmit = {
          ...dataSubmit,
          enable_template_limit: true,
          daily_template_limit: this.daily_template_limit ? Number(this.daily_template_limit) : null,
          monthly_template_limit: this.monthly_template_limit ? Number(this.monthly_template_limit) : null
        }
      }      
      this.$emit('submit', dataSubmit);
    },
    async resetPassword() {
      try {
        await Auth.resetPassword({ email: this.value.email });
        this.showAlert(this.$t('AGENT_MGMT.EDIT.PASSWORD_RESET.ADMIN_SUCCESS_MESSAGE'));
      } catch (error) {
        this.showAlert(this.$t('AGENT_MGMT.EDIT.PASSWORD_RESET.ERROR_MESSAGE'));
      }
    },
    removeRowAccount(index){
      this.accounts.splice(index, 1);      
    },
    getMockupAccount(){
      return {
        account: null,
        role: null,
        inboxes: {
          options: [],
          selecteds: []
        },
        teams: {
          options: [],
          selecteds: []
        },
        loading: false        
      }
    },
    clone(objectClone){
      return JSON.parse(JSON.stringify(objectClone));
    },
    addRowAccount(){
      this.accounts.push(this.getMockupAccount());      
    },
    getSubaccountOptionsByIndex(index){
      const idsSelected = this.accounts.filter((item, i) => i !== index && item.account).map(item => item.account.id);
      return this.subaccountsSorted.filter(subaccount => !idsSelected.includes(subaccount.id));
    },
    async onChangeSubAccount(subaccount, item){
      if(!subaccount || this.isEdit){
        return;
      }
      item.loading = true;
      try{
        const [responseInboxes, responseTeams] = await Promise.all([
          InboxesAPI.getByAccount(subaccount.id),
          TeamsAPI.getByAccount(subaccount.id),
        ]);
        item.inboxes.options = responseInboxes.data.payload ? responseInboxes.data.payload : responseInboxes.data;
        item.teams.options = responseTeams.data.payload ? responseTeams.data.payload : responseTeams.data;
        item.inboxes.selecteds = [];
        item.teams.selecteds = []
        if(item.inboxes.options.length == 1){
          item.inboxes.selecteds = this.clone(item.inboxes.options);
        }
        if(item.teams.options.length == 1){
          item.teams.selecteds = this.clone(item.teams.options);
        }
      }catch(error){
        item.account = null;
        this.showAlert(this.$t('AGENT_MGMT.FORM.ERROR_FETCH_SUBACCOUNT_INFO'));
      }finally{
        item.loading = false;
      }
    },
    showTeamsField(itemSubaccount){
      return (
        !this.isEdit
        && itemSubaccount.account && itemSubaccount.role
        && itemSubaccount.role.name != "team_supervisor"
      );
    },
    getLabelRule(key){
      const rulesLabel = {
        unassigned: this.$t('AGENT_MGMT.RULES.UNASSIGNED'),
        contact: this.$t('AGENT_MGMT.RULES.CONTACT'),
        mask_number: this.$t('AGENT_MGMT.RULES.MASK_NUMBER'),
        campaign: this.$t('AGENT_MGMT.RULES.CAMPAIGN'),
        portal: this.$t('AGENT_MGMT.RULES.HELP_CENTER'),
        export_contacts: this.$t('AGENT_MGMT.RULES.EXPORT_CONTACTS'),
        change_conversation_assignment: this.$t('AGENT_MGMT.RULES.CHANGE_CONVERSATION_ASSIGNMENT'),
        multi_conversation_selector: this.$t('AGENT_MGMT.RULES.MULTI_CONVERSATION_SELECTOR'),
        call_outgoing: this.$t('AGENT_MGMT.RULES.CALL_OUTGOING'),
        create_shortcut: this.$t('AGENT_MGMT.RULES.CREATE_SHORTCUT'),
        enable_template_limit: this.$t('AGENT_MGMT.EDIT.TEMPLATE_LIMIT.LABEL'),
        daily_template_limit: this.$t('AGENT_MGMT.EDIT.TEMPLATE_LIMIT.DAILY.LABEL'),
        monthly_template_limit: this.$t('AGENT_MGMT.EDIT.TEMPLATE_LIMIT.MONTHLY.LABEL')
      }
      return rulesLabel[key] ?? key;
    }
  },
};
</script>

<style lang="scss" scoped>
  .form-agent-multi-account{
    fieldset{
      width: 100%;
      border-radius: var(--border-radius-normal);
      border: 1px solid var(--color-border);      
      padding: 0 var(--space-normal);
      margin-bottom: var(--space-normal);
      legend{
        font-size: var(--font-size-medium);
        margin: 0 0 var(--space-normal) 0;
      }
      .medium-12{
        margin-bottom: 1.6rem;
      }
      
      .item-account{
        margin-bottom: var(--space-small);
        padding: var(--space-normal);
        border-radius: var(--border-radius-large);
        border: 1px solid var(--color-border);
        background: var(--color-background-light);
        margin-bottom: var(--space-normal);
        .row{
          position: relative;
          .account-loading-overlay, .account-loading{
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            z-index: 1;
          }
          .account-loading-overlay{
            background: #FFFFFF;
            opacity: 0.5;
          }
          .account-loading{
            z-index: 2;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          
          .columns{
            &:not(.column-actions){
              width: calc(100% - 30px);
            }
            &.column-actions{
              max-width: 30px;
              display: flex;
              align-self: center;
            }
            margin-right: var(--space-small);
            &:last-of-type{
              margin-right: 0;
            }
          }
          .error .message{
            margin: 0;
          }
        }
      }
    }
  }
</style>
